<template>
	<my-dialog :visible.sync="showDialog" title="销售订单详情" dialog-type="form" :close-on-click-modal="false" width="80%" @close="closeDialog">
		<detail ref="detail"></detail>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="closeDialog">关闭</el-button>
			</div>
		</template>
	</my-dialog>
</template>
<script>
import detail from "@/views/product/sales/detail.vue";
export default {
	props: [],
	data() {
		return {
			showDialog: false
		};
	},
	components: {
		detail
	},
	created() {},
	methods: {
		// 显示
		getDetailDialog(row) {
			this.showDialog = true;
			this.$nextTick(() => {
				this.$refs.detail.getDetail(row);
			});
		},
		// 关闭
		closeDialog() {
			this.showDialog = false;
		}
	}
};
</script>
<style scoped lang="scss"></style>
